module.exports = __webpack_public_path__ + "img/MobileLink_Logo_2023_COLOR.ca6b9102.svg";